module.exports = __webpack_public_path__ + "static/media/card.1176db31.svg";